import { Link } from "react-router-dom";
import { FEATURE_ACCOMPAGNEMENT, FEATURE_CORRESPONDANCE } from "../config/features";

const IMG = "https://images.unsplash.com/photo-1603950227760-e609ce8e15b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxjdXAlMjBvZiUyMHRlYSUyMGFuZCUyMG9wZW4lMjBib29rJTIwbWluaW1hbGlzdHxlbnwwfHx8fDE3ODkyMDYxMTV8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-6xl mx-auto px-6 md:px-12 pt-16 pb-20 grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5">
          <img src={IMG} alt="Bureau d'Amélie, livre et thé" className="w-full h-[520px] object-cover"/>
        </div>
        <div className="md:col-span-7">
          <p className="font-hand text-2xl text-[#A3876A] mb-4">Derrière Les RDV de l'écriture</p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-4 leading-tight">
            Amélie, <em className="italic">passionnée par les mots</em>.
          </h1>
          <p className="font-hand text-xl text-[#A3876A] mb-10">Qui se cache derrière ces mots ?</p>

          <div className="text-[#4A4036] text-lg leading-relaxed space-y-6">
            <p>Je suis Amélie, anciennement éducatrice spécialisée et passionnée par les mots.</p>

            <p>
              J'ai toujours aimé ce que l'écriture permet : mettre de l'ordre dans ce que l'on ressent, garder une trace, dire ce que l'on n'arrive pas toujours à dire à voix haute.
            </p>

            <p>
              J'aime les mots qui restent. Les histoires ordinaires qui ne le sont jamais vraiment. Les lettres que l'on garde dans une boîte. Les phrases que l'on relit des années plus tard.
            </p>

            <p>
              J'ai créé Les RDV de l'écriture pour offrir des espaces où l'on peut simplement prendre le temps d'écrire. Sans avoir besoin d'être écrivain.
            </p>

            <p>
              Alors j'écris. Je propose. J'écoute. Je lis. Et surtout, je laisse une place aux mots.
            </p>

            <p>
              Je réponds moi-même à chaque lettre. C'est pour cela que je limite à trente places de correspondance par mois : je veux vraiment te lire.
            </p>

            <p className="font-hand text-2xl text-[#A3876A] mt-8">— Amélie</p>
          </div>
        </div>
      </section>

      {/* Fil rouge — positionnement */}
      <section className="bg-[#F5F0E6] py-20 border-y border-[#E8DCC8]">
        <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
          <p className="font-hand text-2xl text-[#A3876A] mb-6">Le fil rouge</p>
          <p className="font-serif text-xl md:text-2xl lg:text-3xl text-[#2C2621] leading-snug italic md:whitespace-nowrap">
            «&nbsp;Les mots comme rendez-vous avec soi et avec les autres.&nbsp;»
          </p>
        </div>
      </section>

      {/* Invitations douces */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 py-20 text-center">
        <h2 className="font-serif text-3xl md:text-4xl text-[#2C2621] leading-tight mb-8">
          Et si on <em className="italic">se rencontrait</em> autour d'un rendez-vous ?
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/programme" className="btn-primary">Je découvre les rendez-vous</Link>
          {FEATURE_CORRESPONDANCE && (
            <Link to="/correspondance" className="btn-outline">Je découvre la correspondance</Link>
          )}
          {FEATURE_ACCOMPAGNEMENT && (
            <Link to="/accompagnement" className="btn-outline">L'accompagnement d'écriture</Link>
          )}
        </div>
      </section>
    </div>
  );
}
